import { StatusIconType } from '@uigy/shared/components/icons/interfaces';
import { Observable } from 'rxjs';
import { UiGridFilterModel } from '@uigy/shared/components/ui-grid/models/ui-grid';
import { TimeFrameItem } from '@uigy/shared/services/time-frame.service';
import { BadgeConfig } from '@uigy/shared/components/ui-badge/ui-badge.interfaces';

export interface MainKpiData {
  count: number;
  riskCount: number;
  statusIcon: StatusIconType;
}

interface BaseKpiConfig<T = any> {
  title: string;
  callbackFn?: (config: BaseKpiConfig<T>) => void;
  isClickable?: boolean;
  timeFrameValue?: TimeFrameItem;
}

export interface MainKpiConfig<T = any> extends BaseKpiConfig<T> {
  fetchData: (filter: UiGridFilterModel<T>[]) => Observable<MainKpiData>;
  filter: UiGridFilterModel<T>;
  subTitle: string;
  riskFilter: UiGridFilterModel<T>;
  riskScoreTooltip?: string;
}

export interface WhatsNewKpiConfig<T = any> extends BaseKpiConfig<T> {
  fetchData: (filter?: UiGridFilterModel<T>) => Observable<number> | Observable<KpiSmallRatioData>;
  filter?: (value: TimeFrameItem) => UiGridFilterModel<T>;
  badgeConfig?: BadgeConfig;
  kpiGridLayoutConfig?: WhatsNewKpiLayoutConfig;
  kpiVariant?: KpiSmallVariant;
}

interface WhatsNewKpiLayoutConfig {
  rowStart: number;
  columnStart: number;
  rowEnd: number;
  columnEnd: number;
}

export interface KpiSmallRatioData {
  currentValue: number;
  totalValue: number;
}

export enum KpiSmallVariant {
  Basic = 'BASIC',
  Ratio = 'RATIO',
}
